import React from "react";
import moment from "moment";
import {
  Percent,
  IndianRupee,
  ArrowDownCircle,
  Wallet,
  CalendarDays,
} from "lucide-react";

const fmt = require("indian-number-format");

export default function InterestCard({ item }) {
  return (
    <div className="rounded-2xl mt-2 border-2 border-[var(--hover)] bg-[var(--background)] p-4 shadow-md transition-all duration-300">
      {/* Header */}
      <div className="flex justify-between items-center mb-2">
        <div className="flex items-center gap-2">
          <ArrowDownCircle className="text-[var(--sell)]" size={22} />
          <p className="text-base font-semibold text-[var(--text)]">
            Interest Credit
          </p>
        </div>

        <p className="text-xs text-[var(--subtext)]">
          {moment(item.date).format("DD MMM, YYYY")}
        </p>
      </div>

      {/* Core Numbers */}
      <div className="mt-2 grid grid-cols-2 gap-4 text-sm">
        <div className="flex items-center gap-2">
          <Percent size={16} className="text-[var(--buy)]" />
          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className="font-semibold">Interest Rate</span>
            <span className="font-semibold">{item.interest_rate}%</span>
            <span className="font-semibold">{item.interest_rate_year}% (Year)</span>
          </span>
        </div>

        <div className="flex items-center gap-2">
          <IndianRupee size={16} className="text-[var(--buy)]" />
          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className={"font-semibold"}>Interest Amount</span>
            <span className={"text-[var(--sell)] font-semibold"}>
              {" ₹" + item.interest_amount}
            </span>
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Wallet size={16} className="text-[var(--subtext)]" />
          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className="text-[10px] font-semibold">Cash Deposit</span>
            <span className="text-[13px] font-semibold">
              {fmt.format(item.deposit_available)}
            </span>
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Wallet size={16} className="text-[var(--subtext)]" />
          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className="text-[10px] font-semibold">Total Deposit</span>
            <span className="text-[13px] font-semibold">
              {fmt.format(item.deposit_total)}
            </span>
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Wallet size={16} className="text-[var(--subtext)]" />

          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className="text-[10px] font-semibold">Deposit Current</span>
            <span className="text-[13px] font-semibold">
              ₹{fmt.format(item.deposit_current)}
            </span>
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Wallet size={16} className="text-[var(--subtext)]" />
          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className="text-[10px] font-semibold">Deposit Use</span>
            <span className="text-[13px] font-semibold">
              {fmt.format(item.deposit_use)}
            </span>
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Wallet size={16} className="text-[var(--subtext)]" />

          <span className="text-[var(--text)] flex flex-col font-medium">
            <span className="text-[13px] font-semibold">Interest Amount</span>
            <span className="text-[17px] font-semibold">
              ₹{fmt.format(item.deposit_interest_amt)}
            </span>
          </span>
        </div>
      </div>

      {/* Footer Info */}
      <div className="mt-4 flex justify-between text-xs text-[var(--subtext)]">
        <div className="flex items-center gap-2">
          <CalendarDays size={14} />
          <span>{moment(item.date_created).format("DD-MM-YYYY hh:mm A")}</span>
        </div>

        <span>ID: {item.id || "N/A"}</span>
      </div>
    </div>
  );
}
